import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'

import { StoryKeys, StoryKey, NodeStoryKeys, Path } from '@/types'

export const SOURCE_PANEL = 'panel'
export const SOURCE_CONFIG_PATH = 'configPath'

const props = {
  usePrimaryStore: Boolean,
  configPath: {
    // Used to get content from a single source eg faq & splashscreen
    type: Array as PropType<string[]>,
    default: () => [],
  },
  panel: {
    // If no config path, used to get content for the current path
    // If config path, will get the story settings in TTReader
    type: String as PropType<StoryKey>,
    default: StoryKeys.SIDEBAR_TOP,
  },
  editorHeight: {
    type: String,
    default: null,
  },
}

@Component
export default class TTMixin extends Vue.extend({ props }) {
  showParent = true

  get defaultStoryPathToEdit (): string | null {
    // Abstract method - should be ovewritten
    return ''
  }

  get source () {
    return this.configPath.length === 0 ? SOURCE_PANEL : SOURCE_CONFIG_PATH
  }

  get configPathContent () {
    if (this.usePrimaryStore) {
      return this.$typedStore.primary.app.nestedConfig(this.configPath)
    }

    return this.$typedStore.activeVisualisation.visualisationStore.app.nestedConfig(this.configPath)
  }

  set configPathContent (newValue) {
    // eg infoPanel and splashScreen
    this.$typedStore.primary.app.updateConfig({
      configPath: this.configPath,
      value: newValue,
    })
  }

  get panelContent () {
    if (this.usePrimaryStore) {
      return this.$typedStore.primary.app.story(this.path, this.panel as NodeStoryKeys, this.showParent)
    }

    return this.$typedStore.activeVisualisation.visualisationStore.app.story(this.path, this.panel as NodeStoryKeys, this.showParent)
  }

  set panelContent (newValue) {
    // eg all node related content, such as sidebarTop or customTitle
    this.$typedStore.primary.entities.nodes.updateNodeValue({
      path: this.path.toString(),
      key: this.panel as NodeStoryKeys,
      value: newValue,
    })
  }

  get content () {
    if (this.source === SOURCE_PANEL) {
      return this.panelContent
    } else if (this.source === SOURCE_CONFIG_PATH) {
      return this.configPathContent
    } else {
      return ''
    }
  }

  set content (newValue) {
    if (this.source === SOURCE_PANEL) {
      this.panelContent = newValue
    } else if (this.source === SOURCE_CONFIG_PATH) {
      this.configPathContent = newValue
    } else {
      console.log('Error storing story', newValue)
    }
  }

  get path () {
    if (!this.defaultStoryPathToEdit) {
      return this.$typedStore.activeVisualisation.storyPath
    }
    return new Path({ path: this.defaultStoryPathToEdit })
  }
}
